import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { NamedLink } from '../../components';

import css from './TabNav.module.css';

const Tab = props => {
  const {
    className,
    id,
    disabled,
    text,
    selected,
    linkProps,
    linkClassName,
    selectedLinkClassName,
    disabledLinkClassName,
  } = props;
  // The three *LinkClassName props let a single page restyle its own tab links
  // without touching this shared component's look anywhere else. When they are
  // not given, the default TabNav.module.css classes are used as before.
  const linkClasses = classNames(linkClassName || css.link, {
    [selectedLinkClassName || css.selectedLink]: selected,
    [disabledLinkClassName || css.disabled]: disabled,
  });

  return (
    <div id={id} className={className}>
      <NamedLink className={linkClasses} {...linkProps}>
        {text}
      </NamedLink>
    </div>
  );
};

Tab.defaultProps = {
  className: null,
  disabled: false,
  selected: false,
  linkClassName: null,
  selectedLinkClassName: null,
  disabledLinkClassName: null,
};

const { arrayOf, bool, node, object, string } = PropTypes;

Tab.propTypes = {
  id: string.isRequired,
  className: string,
  text: node.isRequired,
  disabled: bool,
  selected: bool,
  linkProps: object.isRequired,
  linkClassName: string,
  selectedLinkClassName: string,
  disabledLinkClassName: string,
};

const TabNav = props => {
  const {
    className,
    rootClassName,
    tabRootClassName,
    tabs,
    linkClassName,
    selectedLinkClassName,
    disabledLinkClassName,
  } = props;
  const classes = classNames(rootClassName || css.root, className);
  const tabClasses = tabRootClassName || css.tab;
  const linkClassNames = { linkClassName, selectedLinkClassName, disabledLinkClassName };
  return (
    <nav className={classes}>
      {tabs.map((tab, index) => {
        const id = typeof tab.id === 'string' ? tab.id : `${index}`;
        return <Tab key={id} id={id} className={tabClasses} {...linkClassNames} {...tab} />;
      })}
    </nav>
  );
};

TabNav.defaultProps = {
  className: null,
  rootClassName: null,
  tabRootClassName: null,
  tabClassName: null,
  linkClassName: null,
  selectedLinkClassName: null,
  disabledLinkClassName: null,
};

TabNav.propTypes = {
  className: string,
  rootClassName: string,
  tabRootClassName: string,
  tabs: arrayOf(object).isRequired,
  linkClassName: string,
  selectedLinkClassName: string,
  disabledLinkClassName: string,
};

export default TabNav;
